import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import React, { FunctionComponent, ReactElement, ReactNode } from "react";
import ReactDOM from "react-dom";
import { ReactComponent as IconX } from "../../../../icons/16x16/x.svg";
import "./style.scss";

let modalRoot = document.getElementById("modal-root");
if (!modalRoot) {
  modalRoot = document.createElement("div");
  modalRoot.setAttribute("id", "modal-root");
  document.body.appendChild(modalRoot);
}

const AnimatedModal = ({ className, children }: { className: string; children: ReactNode }) => (
  <motion.div
    animate={{
      opacity: 1,
      transition: { delay: 0.2 },
      y: 0,
    }}
    exit={{ opacity: 0, y: -200 }}
    initial={{ opacity: 0, y: -200 }}
    transition={{ duration: 0.2 }}
    className={className}
  >
    {children}
  </motion.div>
);
const AnimatedOverlay = ({ className, onClick }: { className: string; onClick: () => void }) => (
  <motion.div
    animate={{ opacity: 1 }}
    exit={{
      opacity: 0,
      transition: { delay: 0.2 },
    }}
    initial={{ opacity: 0 }}
    transition={{ duration: 0.2 }}
    className={className}
    onClick={onClick}
  />
);

export const AnimatedPortal: FunctionComponent<{
  children: ReactElement<unknown> | never[];
}> = ({ children }) => {
  return ReactDOM.createPortal(
    <AnimatePresence>{children}</AnimatePresence>,
    modalRoot || document.body
  );
};

interface ModalProps {
  children: ReactNode;
  className?: string;
  display: boolean;
  onDismiss: () => void;
  showCloseButton?: boolean;
  type?: "action" | "default" | "information";
}

const ModalSmily: FunctionComponent<ModalProps> = ({
  children,
  className = "",
  display,
  onDismiss,
  showCloseButton,
  type = "default",
}) => {
  const modalContent = display ? (
    <motion.div
      key="modal"
      className={classNames("ModalSmily", className, {
        "ModalSmily--action": type === "action",
        "ModalSmily--information": type === "information",
      })}
    >
      <AnimatedOverlay className="ModalSmily-overlay" onClick={onDismiss} />
      <AnimatedModal className="ModalSmily-content">
        <>
          {children}
          {showCloseButton ? (
            <span className="ModalSmily-content-close" onClick={onDismiss}>
              <IconX />
            </span>
          ) : null}
        </>
      </AnimatedModal>
    </motion.div>
  ) : (
    []
  );
  return <AnimatedPortal>{modalContent}</AnimatedPortal>;
};

export default ModalSmily;
